import { useTheme } from "@mui/material";
import { MCTooltip } from "../../../MainComponents";
import Icon from "../../../Icon/Icon";

const ModalInfoTitle = ({ title, information }) => {
  const theme = useTheme();

  return information ? (
    <MCTooltip position="left" text={information}>
      <h5>
        {title} <Icon name="info_circle" size={16} color={theme.palette.primary.main} />
      </h5>
    </MCTooltip>
  ) : (
    <h5>{title}</h5>
  );
};

export default ModalInfoTitle;